import { EVENTS } from '../../../lib/constants';
import { GameConfigs } from '../../../lib/globals/GameConfigs';
import HELPERS from '../../../lib/globals/helpers/Helpers';

export function sendfreeSpinStep() {
	HELPERS.dispatchCustomEvent(EVENTS.BET_PLACED, { placed: true });
	window.connectionProvider.freeRoundStep(
		JSON.stringify({
			service: 'freespinstep',
			data: {}
		})
	);
}

export function sendManualBet() {
	//call custom event - bet is placed
	HELPERS.dispatchCustomEvent(EVENTS.BET_PLACED, { placed: true });
	//send manual bet, check for quest
	window.connectionProvider.bet(
		JSON.stringify({
			service: 'bet',
			data: {
				amount: GameConfigs.currentBet.toString(),
				doublefeaturechance: GameConfigs.doubleChance ? 1 : 0,
				buybonus: 0,
				questid:
					GameConfigs.quest_claim.activated_item > 0
						? GameConfigs.quest_claim.activated_item
						: 0
			}
		})
	);
}
